var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('div',{}),_c('h4',{staticClass:"text-1"},[_vm._v(_vm._s(_vm.$t('errors.notFound.title')))]),_c('div',{staticClass:"link-container"},[_c('v-btn',{attrs:{"depressed":"","color":"white secondary--text mt-5"},on:{"click":_vm.goBack}},[_vm._v(" "+_vm._s(_vm.$t('errors.notFound.goto'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }